import { useEffect } from "react";
import { useServicesContext } from "../context/services-context";
import { useServicesUIStore } from "../store/use-services-ui-store";

export function useSearchExpand() {
  const {
    searchTerm,
    expandedCategories,
    manuallyToggled,
    setExpandedCategories,
    setManuallyToggled,
    autoExpandForSearch,
  } = useServicesUIStore();

  const { filteredCategories } = useServicesContext();

  // Auto-expand categories when searching (only if not manually toggled)
  useEffect(() => {
    if (!manuallyToggled) {
      if (searchTerm && expandedCategories.size === 0 && filteredCategories.length > 0) {
        autoExpandForSearch(filteredCategories.map((c) => c.id));
      } else if (
        !searchTerm &&
        expandedCategories.size === filteredCategories.length &&
        filteredCategories.length > 0
      ) {
        setExpandedCategories(new Set());
      }
    }
  }, [
    searchTerm,
    filteredCategories,
    expandedCategories.size,
    manuallyToggled,
    autoExpandForSearch,
    setExpandedCategories,
  ]);

  // Reset manual toggle flag when search term changes
  useEffect(() => {
    setManuallyToggled(false);
  }, [setManuallyToggled]);
}
